import React, { Component } from 'react'
import Cleave from 'cleave.js/react'
import moment from 'moment'

class CreditExpiryFieldYear extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	render() {
		const {input, size, label,  meta: { valid, touched, error }} = this.props
		let selectOptions = []

		let startYear = moment(new Date(), 'YY')
		const endYear = moment(startYear, 'YY').add(10, 'years')

		while (startYear.isSameOrBefore(endYear)) {
			selectOptions.push(
						<option
							key={ `cc-date-${moment(startYear).format('YY')}`}
							value={ moment(startYear).format('YY') }
						>
							{ moment(startYear).format('YY') }
						</option>
			)
			startYear = startYear.add(1, 'years')
		}

		return (
			<div className={
				touched && error ?
					'u-form-col u-form-col--error u-form-col--' + size
					: touched && valid ?
					'u-form-col u-form-col--valid u-form-col--' + size
					:
					'u-form-col u-form-col--' + size
			}>
				{ process.env.REACT_APP_COMPONENT_PAYMENT_CREDIT_CARD_EXPIRY_YEAR_LAYOUT === 'select' ?
					<select
						{ ...input }
						className='u-form-select'
						aria-labelledby={ input.name + 'Label' }
						id="cc-expiry-year"
					>
						{ selectOptions }
					</select>
				:
					<Cleave
					{...input}
						aria-labelledby={ input.name + 'Label' }
						options={{date: true, datePattern: ['YY']}}
						id="cc-expiry-year"
					/>
				}

				<label id={ input.name + 'Label' } className="u-form-label u-form-label--bottom u-txt-center" htmlFor={ input.name }>{label}</label>

				{touched && ((error && <p className="u-font-error">{error}</p>))}
			</div>
		)
	}
}

export default CreditExpiryFieldYear


// WEBPACK FOOTER //
// ./src/components/forms/creditCardForm/elements/CreditExpiryFieldYear.js